import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

export const CustomDropdown = React.memo((props) => {
    const { request, requestParams, dependencies, onChangeEvent, onChange, initialValue, doRender, setFirstValue, isSearcheable, setDisabled,  ...others } = props;
    const [dataSource, setDataSource] = useState([]);
    const [value, setValue] = useState(null);

    function findObjectById(objectList, id) {
        const foundObject = objectList.find(obj => obj.id === id);
        return foundObject || null;
    };

    const _setFirstValue = setFirstValue ?? false;
    const _doRender = doRender ?? true;
    const _dependencies = (dependencies ? dependencies : []).concat([initialValue, doRender]);
    const _isSearcheable = isSearcheable ?? false;
    const _setDisabled = setDisabled ?? true;
    
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (request && _doRender) {
            request(requestParams ? requestParams : {})
                .then(response => {
                    if (response) {
                        setDataSource(response);

                      
                        if (initialValue != null && initialValue != undefined) {
                            const initValue = findObjectById(response, initialValue);
                            handleOnChange({ value: initValue })
                        }

                        if (response.length == 1 && _setFirstValue) {
                            handleOnChange({ value: response[0] })
                        }
                       
                    }
                })
                .catch(error => {
                    console.error('Failed to fetch data:', error);
                });
        }

    }, _dependencies);

    const handleOnChange = (e) => {
        var _value = e?.value ?? null;

        if (_value?.id == value?.id) {
            return;
        }

        setValue(_value);

     

        if (onChangeEvent) {
            const simulatedEvent = {
                target: {
                    name: props.name,
                    value: _value
                },
                setValue: setValue
            };
            onChangeEvent(simulatedEvent);
        }

        // pt onchange de pe form
        if (onChange) { onChange(e); }

        setSearchTerm("");
    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
    };

    const filtred = searchTerm ? dataSource.filter((item) => item.text.toLowerCase().includes(searchTerm.toLowerCase())) : dataSource;

    return (
        <>
            <DropDownList
                onChange={handleOnChange}
                data={isSearcheable ? filtred : dataSource}
                textField="text"
                dataItemKey="id"
                value={value}
                onFilterChange={handleFilterChange}
                disabled={dataSource.length == 1 && _setDisabled ==true}
                {...others}  />
        </>
    );
});
